/**
 * Created by decipaliz on 22.05.2024
 */

Mission.TYPE_PRIZE_CALENDAR = 10;

Mission.REGISTRATIONS.set(Mission.TYPE_PRIZE_CALENDAR, () => ({
    available: cleverapps.config.availables.PRIZE_CALENDAR_MISSION,
    abTest: function () {
        return cleverapps.abExperiments.getGroup(ABExperiments.Tests.prizecal) === "A";
    },
    name: "prizecalendar",
    view: PrizeCalendarWindow,
    startWindow: PrizeCalendarWindow,
    nudgeWindow: PrizeCalendarWindow,
    iconForce: Forces.PRIZE_CALENDAR,
    logic: PrizeCalendarMissionLogic,
    semaphore: Mission.SEMAPHORE_CUSTOM_PRIZE_CALENDAR,
    sideBarJson: bundles.sidebar.jsons.prize_calendar_icon_json,
    duration: "180 minutes",
    bundle: "prizecalendar"
}));